import { useDidMount } from './useDidMount';
import { useActions } from 'store';
import { initializeSession } from 'store/session/actions';

export function useInitialization() {
    const actions = useActions({ initializeSession });

    useDidMount(() => {
        actions.initializeSession();
    });
}
